function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "9",
  height: "15",
  viewBox: "0 0 9 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M8.245 2.432a.878.878 0 10-1.242-1.241L1.31 6.888a.866.866 0 000 1.224L7.01 13.81a.876.876 0 001.239-1.239l-5.072-5.07 5.068-5.069z",
  fill: "#057CCC"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.696.885a1.311 1.311 0 111.856 1.854L3.79 7.5l4.765 4.765a1.31 1.31 0 11-1.852 1.852L1.006 8.419a1.3 1.3 0 010-1.837L6.695.885zm1.242.61a.445.445 0 00-.629.002L1.618 7.194a.433.433 0 000 .612l5.698 5.698a.443.443 0 10.626-.626L2.565 7.5l5.374-5.374a.445.445 0 000-.63z",
  fill: "#057CCC"
})));